import ShippingAds from './ShippingAds'

export default ShippingAds
